import { makeStyles } from "tss-react/mui";

import { Theme } from "@mui/material";

export const useStyles = makeStyles()((muiTheme: Theme) => ({
    scrollContainer: {
        height: 500,
        overflowY: "auto",
        padding: muiTheme.spacing(2),
    },
    centeredBox: {
        height: 500,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    noActivityText: {
        textAlign: "center",
        borderBottom: "none",
        padding: 0,
    },
    deviceSummaryIndicator: {
        width: "3px",
        borderRadius: "18px",
        height: 40,
        marginRight: muiTheme.spacing(4),
    },
    eventItem: {
        display: "flex",
        alignItems: "center",
        padding: muiTheme.spacing(3, 0),
        minHeight: 64,
    },
    eventContent: {
        display: "flex",
        flex: 1,
        justifyContent: "space-between",
        alignItems: "center",
    },
    primaryBlock: {
        flex: 1,
        flexDirection: "column",
        marginRight: muiTheme.spacing(2),
    },
    secondaryBlock: {
        flex: "0 0 auto",
        textAlign: "right",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end",
        justifyContent: "flex-start",
    },
    secondaryBlockContent: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end",
        gap: muiTheme.spacing(0.5),
    },
    primaryText: {
        fontWeight: 500,
        color: muiTheme.palette.emteria.text.primary,
        margin: 0,
    },
    secondaryText: {
        fontWeight: 400,
        color: muiTheme.palette.text.secondary,
        margin: "4px 0 0 0",
    },
    dateTimeText: {
        fontWeight: 400,
        color: muiTheme.palette.text.secondary,
        margin: "4px 0 0 0",
        textAlign: "right",
        paddingBottom: 5,
    },
}));
